import 'scrollyfills';

import { useEffect, useRef, useState } from 'react';

const THRESHOLD = 5; // 스크롤 방향을 감지할 임계값

export const DIRECTION_UP = 'UP';
export const DIRECTION_DOWN = 'DOWN';

type ScrollDirection = typeof DIRECTION_UP | typeof DIRECTION_DOWN;

function useScrollDirectionWithY() {
  const [scrollDirection, setScrollDirection] =
    useState<ScrollDirection>(DIRECTION_UP);
  const [scrollY, setScrollY] = useState<number>(window.scrollY);
  const [scrollEnd, setScrollEnd] = useState<boolean>(true);

  const prevScrollY = useRef(window.scrollY); // 이전 스크롤 Y값을 추적
  const blocking = useRef(false); // requestAnimationFrame을 위한 blocking 변수

  useEffect(() => {
    // 스크롤 방향과 Y값을 갱신하는 함수
    const updateScroll = () => {
      const currentScrollY = window.scrollY;

      // 스크롤 방향 업데이트
      if (Math.abs(currentScrollY - prevScrollY.current) >= THRESHOLD) {
        const newScrollDirection =
          currentScrollY > prevScrollY.current ? DIRECTION_DOWN : DIRECTION_UP;
        setScrollDirection(newScrollDirection);
      }

      // 스크롤 Y값 업데이트
      setScrollY(currentScrollY);

      // 이전 스크롤 Y값 갱신
      prevScrollY.current = currentScrollY;
    };

    const onScroll = () => {
      if (!blocking.current) {
        blocking.current = true;
        // requestAnimationFrame을 사용하여 성능 최적화
        window.requestAnimationFrame(() => {
          updateScroll();
          if (scrollEnd) setScrollEnd(false);
          blocking.current = false; // 스크롤 업데이트 후 blocking 해제
        });
      }
    };

    const onScrollEnd = () => {
      setScrollEnd(true);
    };

    // 스크롤 이벤트 리스너 등록
    window.addEventListener('scroll', onScroll);
    window.addEventListener('scrollend', onScrollEnd);

    // 컴포넌트 언마운트 시 이벤트 리스너 해제
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('scrollend', onScrollEnd);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // 의존성 배열을 빈 배열로 설정하여 최초 렌더링 시만 실행되도록

  return {
    scrollY, // 현재 스크롤 Y값
    scrollDirection, // 스크롤 방향 (up | down)
    scrollEnd,
  };
}

export default useScrollDirectionWithY;
